import React, { useState } from "react";
import Projects from "../../pages/projects/";
import BlogsComponent from "../../components/blogs";
import OpenSource from "../../pages/opensource/OpenSource";
import Talks from "../talks";
import Papers from "../papers";

const Content = () => {
  const [current, setCurrent] = useState("projects");
  return (
    <div className="pt-8 border-b border-neutral-700 w-[90%] mx-auto ">
      <div className="text-sm pb-8 flex items-center justify-center gap-4 md:gap-8 border-b border-neutral-700">
        <button
          className={`
          ${current === "projects" ? "text-white" : "text-neutral-400"}
          transition-all duration-100
          `}
          onClick={() => setCurrent("projects")}
        >
          Projects
        </button>
        <button
          className={`
          ${current === "blogs" ? "text-white" : "text-neutral-400"}
         transition-all duration-100
          `}
          onClick={() => setCurrent("blogs")}
        >
          Blogs
        </button>
        <button
          className={`
          ${current === "opensource" ? "text-white" : "text-neutral-400"}
         transition-all duration-100
          `}
          onClick={() => setCurrent("opensource")}
        >
          Open Source
        </button>
        <button
          className={`
          ${current === "talks" ? "text-white" : "text-neutral-400"}
         transition-all duration-100
          `}
          onClick={() => setCurrent("talks")}
        >
          Talks
        </button>
        <button
          className={`
          ${current === "papers" ? "text-white" : "text-neutral-400"}
         transition-all duration-100
          `}
          onClick={() => setCurrent("papers")}
        >
          Papers
        </button>
      </div>

      {current === "projects" && <Projects />}
      {current === "blogs" && <BlogsComponent />}
      {current === "opensource" && <OpenSource />}
      {current === "talks" && <Talks />}
      {current === "papers" && <Papers />}
    </div>
  );
};

export default Content;
